import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const asyncFiles = require.context('./systemModules', true, /\.ts$/)
let permissionModules: Array<RouteRecordRaw> = []
asyncFiles.keys().forEach((key) => {
  if (key === './index.ts') return
  permissionModules = permissionModules.concat(asyncFiles(key).default)
})
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  ...permissionModules
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
